import React from 'react';
import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum, AppAction } from 'qcc'
import api, { AppOrgan } from 'api'
import { appEnum } from 'utils/appEnum'

const organTypeOptions = [{ label: '公司', value: '1' }, { label: '部门', value: '2' }]

export default class OrganEdit extends React.PureComponent<AppFormPageProps> {
  state = {
    parentOrgan: (this.props.extraData || { fullCode: '' }) as AppOrgan
  }

  save = async (formData: AppOrgan) => {
    return this.props.mode === 2 ? await api.apporgan.update(formData) : await api.apporgan.create(formData);
  }

  afterSave = () => {
    this.props.afterSave && this.props.afterSave();
    AppAction.closeDialog();
  }

  render() {
    let { formData, mode, id } = this.props;
    let { parentOrgan } = this.state;
    return (<AppFormLayout defaultButton mode={this.props.mode}>
      <AppFormLayout.Form>
        <AppForm loadingData={false}
          save={this.save}
          mode={mode}
          keyValue={id}
          formData={formData}
          afterSave={() => { this.afterSave() }}>
          <AppForm.Section labelWidth={100}>
            <AppForm.Item field='organ_type'
              keyName='organType'
              itemType={AppFormItemEnum.radio}
              options={organTypeOptions}
              label="组织类型"
              dataType="number"
              readonly={parentOrgan.organType === 2 || mode === 2}
            />
            <AppForm.Item field='name' itemType={AppFormItemEnum.input} label="组织名称" req />
            <AppForm.Item field='code' itemType={AppFormItemEnum.input} label="组织编码" prefix={parentOrgan.fullCode} req />
            <AppForm.Item field='md_id' keyName='mdId'
              itemType={AppFormItemEnum.input} label="主数据id" />
            <AppForm.Item field='sap_city' keyName='sapCity' placeholder="该字段录入SAP系统的PCITY，用于后续项目接口对应关系"
              itemType={AppFormItemEnum.input} label="sapPCITY" />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/application/user/OrganEdit.tsx